import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EllipsisButton from './EllipsisButton';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';

const EllipsisDropdown = ({
  listItems,
  className,
  pullRight,
  attributes,
  buttonClassName,
  button
}) => (
  <Dropdown componentClass="div" className={classnames('ellipsis-dropdown', className)} pullRight={pullRight}>
    {!button ? (
      <EllipsisButton buttonClassName={buttonClassName} bsRole="toggle" />
    ) : (
      { ...button }
    )}
    <Dropdown.Menu
      bsRole="menu"
      className="ellipsis-dropdown-menu"
      { ...attributes }
    >
      {
        listItems.map((item, i) => (
          <MenuItem
            key={`menu-item-${i}`}
            href={item.href}
            header={item.header}
            onClick={item.onClick}
            className={item.className}
            data-testing-id={item.testingId}
          >
            {item.title}
          </MenuItem>
        ))
      }
    </Dropdown.Menu>
  </Dropdown>
);

EllipsisDropdown.propTypes = {
  listItems: PropTypes.array,
  className: PropTypes.string,
  pullRight: PropTypes.bool,
  attributes: PropTypes.object,
  buttonClassName: PropTypes.string,
  button: PropTypes.object
};

export default EllipsisDropdown;
